// extracted by mini-css-extract-plugin
module.exports = {"Copy-rights":"copy-rights_Copy-rights__SE_SK","Copy-rights--own-paddings":"copy-rights_Copy-rights--own-paddings__hQysK","Copy-rights__text":"copy-rights_Copy-rights__text__E68Qi"};